import {
  FETCHING_NUDGE_TYPE_REQUEST, FETCHING_NUDGE_TYPE_SUCCEDDED, FETCHING_NUDGE_TYPE_FAILED,
  FETCHING_ENGAGED_CONTACTS_REQUEST, FETCHING_ENGAGED_CONTACTS_SUCCEDDED, FETCHING_ENGAGED_CONTACTS_FAILED,

  FETCHING_REPORT_SUMMARY_REQUEST, FETCHING_REPORT_SUMMARY_SUCCEDDED, FETCHING_REPORT_SUMMARY_FAILED
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = process.env.REACT_APP_API_URL;
const APP_BASE_URL = `${apiUrl}/api/2.0`;
const NUDGE_BASE_URL = `${APP_BASE_URL}/users`;
const ENGAGED_CONTACTS_URL = `${apiUrl}/api/2.0/engaged_contacts`;

export function fetchNudgeType(){
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_NUDGE_TYPE_REQUEST));

    return axios({
      method: 'GET',
      url: `${NUDGE_BASE_URL}/me/nudge/type`
    })
    .then(response =>
      dispatch(fetchingSucceededAction(FETCHING_NUDGE_TYPE_SUCCEDDED,response.data))
    )
    .catch(error =>
      dispatch(fetchingFailedAction(FETCHING_NUDGE_TYPE_FAILED,error))
    )
  }
}

export function fetchEngagedContacts(){
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_ENGAGED_CONTACTS_REQUEST));

    return axios({
      method: 'GET',
      url: ENGAGED_CONTACTS_URL
    })
    .then(response =>
      dispatch(fetchingSucceededAction(FETCHING_ENGAGED_CONTACTS_SUCCEDDED,response.data))
    )
    .catch(error =>
      dispatch(fetchingFailedAction(FETCHING_ENGAGED_CONTACTS_FAILED,error))
    )
  }
}

/**
* Fetch report summary
*/
export function fetchReportSummary(){
  return function (dispatch) {
    dispatch(fetchingReportSummary());

    let url = buildUrl(APP_BASE_URL, {
      path: 'reports/summary'
    });

    return axios({
      method: 'GET',
      url: url
    })
    .then(response =>
      dispatch(fetchingReportSummarySuccedded(response.data))
    )
    .catch(error =>
      dispatch(fetchingReportSummaryFailed(error))
    )
  }
}

function fetchingReportSummary(){
  return {
    type: FETCHING_REPORT_SUMMARY_REQUEST,
    payload: {}
  }
}

function fetchingReportSummarySuccedded(json){
  return {
    type: FETCHING_REPORT_SUMMARY_SUCCEDDED,
    payload: json
  }
}

function fetchingReportSummaryFailed(error){
  console.log(error);
  return {
    type: FETCHING_REPORT_SUMMARY_FAILED,
    payload: error
  }
}


/*
* Common functions
*/
function fetchingAction(type){
  return {
    type: type,
    payload: {}
  }
}

function fetchingSucceededAction(type, json){
  return {
    type: type,
    payload: json
  }
}

function fetchingFailedAction(type, error){
  return {
    type: type,
    payload: error
  }
}

// export function invalidateConversations(){
//   return {
//     type: INVALIDATE_CONVERSATIONS,
//     payload: {}
//   }
// }